import React, { useRef } from 'react';
import { toast } from 'react-toastify';

const AssetPhotoUpload = ({ onUpload, currentPhotos = [] }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const validTypes = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png'];
    const maxSize = 25 * 1024 * 1024; // 25MB

    const validFiles = [];

    for (const file of files) {
      if (!validTypes.includes(file.type)) {
        toast.error(`${file.name} is not a valid image`);
        continue;
      }
      if (file.size > maxSize) {
        toast.error(`${file.name} exceeds 25MB`);
        continue;
      }
      validFiles.push(file);
    }

    if (validFiles.length) {
      onUpload && onUpload(validFiles);
    }

    // allow selecting same file again
    e.target.value = '';
  };

  const handleRemove = (index) => {
    onUpload && onUpload(currentPhotos.filter((_, i) => i !== index));
  };

  return (
    <div className="asset-photo-upload">
      {/* Preview Grid */}
      {currentPhotos.length > 0 && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
            gap: '12px',
            marginBottom: '12px'
          }}
        >
          {currentPhotos.map((photo, index) => (
            <div
              key={index}
              style={{
                position: 'relative',
                border: '2px solid #e2e8f0',
                borderRadius: '6px',
                padding: '4px'
              }}
            >
              <img
                src={photo.preview}
                alt={`Asset ${index}`}
                style={{
                  width: '100%',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '4px'
                }}
              />
              <button
                type="button"
                onClick={() => handleRemove(index)}
                style={{
                  position: 'absolute',
                  top: '4px',
                  right: '4px',
                  background: '#fed7d7',
                  border: 'none',
                  borderRadius: '50%',
                  width: '22px',
                  height: '22px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  color: '#c53030'
                }}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {/* File Input */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/jpg,image/gif,image/png"
        multiple
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />

      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        style={{
          padding: '10px 16px',
          background: '#f7fafc',
          border: '2px solid #e2e8f0',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 500,
          color: '#4a5568'
        }}
      >
        Add Photos
      </button>
    </div>
  );
};

export default AssetPhotoUpload;
